var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReplySolidIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 21.876,
    viewBox: "0 0 25 21.876",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "reply-solid_1_",
    "data-name": "reply-solid (1)",
    d: "M10.01,32.118a1.564,1.564,0,0,1,.928,1.426v3.125h5.469A8.594,8.594,0,0,1,25,45.262a9.575,9.575,0,0,1-4.893,8.5.8.8,0,0,1-.4.093.964.964,0,0,1-.962-.962,1.348,1.348,0,0,1,.479-.952,3.65,3.65,0,0,0,1.084-2.769,4.689,4.689,0,0,0-4.687-4.687H10.937v3.125A1.564,1.564,0,0,1,8.33,48.773L.518,41.742A1.591,1.591,0,0,1,0,40.575a1.572,1.572,0,0,1,.518-1.162L8.33,32.381A1.551,1.551,0,0,1,10.01,32.118Z",
    transform: "translate(0 -31.979)",
    fill: "#21827f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplySolidIcon);
export default __webpack_public_path__ + "static/media/reply-solid-icon.9c93c58b87c9c8fd2be501febec017b4.svg";
export { ForwardRef as ReactComponent };